import { DisplayAction, DisplayValues, FormAction, FormValues } from './types';

export const formReducer = (state: FormValues, action: FormAction) => {
    switch (action.type) {
        case 'changeFormValue':
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };

        case 'changeUserResumeValue': {
            const userResumesAttributes = state.userResumesAttributes || {};

            return {
                ...state,
                userResumesAttributes: {
                    ...userResumesAttributes,
                    [action.payload.index]: {
                        ...userResumesAttributes[action.payload.index],
                        [action.payload.key]: action.payload.value,
                    },
                },
            };
        }
        default:
            return state;
    }
};

export const displayReducer = (state: DisplayValues, action: DisplayAction) => {
    switch (action.type) {
        case 'displayFormValue':
            return {
                ...state,
                [action.payload.displayKey]: action.payload.displayValue,
            };

        default:
            return state;
    }
};
